import React, {memo, FC} from "react";
import moment from "moment";
import {CheckCircleFilled, CloseCircleFilled} from "@ant-design/icons";
import {BookedBy, GetBookingsByCourseIdWithCourseLessonBookingsQuery} from "../../../../generated/graphql";
import AttendeeSection from "./AttendeeSection";
import BookerSection from "./BookerSection";
import css from "./BookingDetails.less";

type BookingDetailsProps = {
    booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0];
};

const BookingDetails: FC<BookingDetailsProps> = ({booking}) => {
    const renderBookingHeader = (
        booking: GetBookingsByCourseIdWithCourseLessonBookingsQuery["bookingsByCourseIdWithCourseLessonBookings"][0],
    ) => {
        const bookingDate = booking?.createDate;
        const bookedOnline = booking.bookedBy === BookedBy.Booker;

        return (
            <div className={css.detailsHeader}>
                <div className={css.headerItem}>
                    <span>{"Buchungsdatum"}</span>
                    <span>{moment(bookingDate).format("DD.MM.YYYY")}</span>
                </div>
                <div className={css.headerItem}>
                    {"Onlinebuchung"}
                    {bookedOnline ? (
                        <CheckCircleFilled /* style={{color: green[4]}} */ />
                    ) : (
                        <CloseCircleFilled /* style={{color: red[4]}} */ />
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className={css.bookingDetailsContainer}>
            {renderBookingHeader(booking)}
            <AttendeeSection booking={booking} />
            <BookerSection booking={booking} />
        </div>
    );
};

export default memo(BookingDetails);
